export const NO_HIGHLIGHT: readonly string[] = []

export const SEARCH_HIT_CLASS = "bg-ui-search-hit text-inherit"

export type HighlightedPart = { text: string; hit: boolean }

function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

export function highlightRanges(text: string, words: readonly string[]): Array<[number, number]> {
  const ranges: Array<[number, number]> = []
  for (const word of words) {
    if (word === "") continue
    for (const match of text.matchAll(new RegExp(escapeRegExp(word), "giu"))) {
      const start = match.index ?? 0
      ranges.push([start, start + match[0].length])
    }
  }
  ranges.sort((a, b) => a[0] - b[0] || a[1] - b[1])
  const merged: Array<[number, number]> = []
  for (const [start, end] of ranges) {
    const last = merged.length > 0 ? merged[merged.length - 1] : null
    if (last && start <= last[1]) last[1] = Math.max(last[1], end)
    else merged.push([start, end])
  }
  return merged
}

export function splitHighlighted(text: string, words: readonly string[]): HighlightedPart[] {
  const parts: HighlightedPart[] = []
  let at = 0
  for (const [start, end] of highlightRanges(text, words)) {
    if (start > at) parts.push({ text: text.slice(at, start), hit: false })
    parts.push({ text: text.slice(start, end), hit: true })
    at = end
  }
  if (at < text.length) parts.push({ text: text.slice(at), hit: false })
  return parts
}
